import React from "react";
import { Box, Chip } from "@mui/material";

const Wormhole = ({ practiceAreas }) => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        perspective: "1200px",
        transformStyle: "preserve-3d",
        position: "relative",
        background: "transparent",
      }}
    >
      {/* Animated Falling Chips using practiceAreas prop */}
      {practiceAreas.map((area, i) => (
        <Chip
          key={i}
          label={area}
          variant="outlined"
          sx={{
            position: "absolute",
            top: "-50px",
            left: `${(i * 7) % 90}%`,
            animation: `fallingChip ${8 + (i % 5)}s linear infinite`,
            animationDelay: `${i * 0.7}s`,
            opacity: 0,
            transform: `rotate(${(i * 25) % 360}deg)`,
            zIndex: 2,
            color: "#472ed1",
            borderColor: "#472ed1",
            background: "rgba(255,255,255,0.9)",
            "&:hover": {
              background: "rgba(255,255,255,1)",
            },
            // Responsive font size
            fontSize: { xs: "0.6rem", sm: "0.7rem", md: "0.8rem" },
            height: { xs: 24, sm: 28, md: 32 },
          }}
        />
      ))}

      {/* SVG Background */}
      <Box
        sx={{
          position: "absolute",
          width: "110%",
          opacity: 0.2,
          bottom: "-10%",
          zIndex: 1,
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 501 297.81"
          style={{
            width: "100%",
            height: "auto",
          }}
        >
          {/* SVG paths and circles (unchanged) */}
          <ellipse
            cx="251.32"
            cy="130.01"
            rx="248.36"
            ry="125.82"
            style={{
              fill: "none",
              stroke: "#472ed1",
              strokeMiterlimit: 10,
              strokeWidth: "2px",
            }}
          />
          <ellipse
            cx="251.73"
            cy="150.5"
            rx="160.66"
            ry="81.39"
            style={{
              fill: "none",
              stroke: "#472ed1",
              strokeMiterlimit: 10,
              strokeWidth: "1.6px",
            }}
          />
          <ellipse
            cx="251.43"
            cy="186.57"
            rx="107.6"
            ry="54.51"
            style={{ fill: "none", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <path
            d="m123.45,22.63c52.05,62.7,97.93,131.45,114.34,213.52.41,2.05,1.23,5.33,1.23,5.33,4.92,18.85,7.79,35.66,10.88,54.9"
            style={{ fill: "none", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <path
            d="m248.86,4.6c2.05,97.95,6.15,194.67,9.31,291.95"
            style={{ fill: "none", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <path
            d="m35.75,67.71c6.15,2.05,11.89,5.33,17.62,8.61,21.31,13.11,40.16,24.59,59.84,40.16,33.61,26.23,56.97,49.59,82.38,84.02,2.46,3.28,6.97,10.25,8.61,13.52,18.03,26.23,31.15,52.46,37.22,82.46"
            style={{ fill: "none", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <path
            d="m5.42,127.55c19.35,2.86,38.36,7.77,56.78,14.33,18.57,6.62,36.53,14.92,53.8,24.41,17.83,9.79,34.96,20.69,50.32,34.09,13.95,12.16,26.41,26.36,36.86,41.65,10.26,14.99,18.58,31.3,24.51,48.48.74,2.15,1.45,4.31,2.11,6.49"
            style={{ fill: "none", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <path
            d="m33.29,190.66c47.95-12.7,102.05-4.51,143.85,27.46,27.05,20.49,45.9,47.54,56.53,78.63"
            style={{ fill: "none", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <path
            d="m137.39,241.48c11.89-12.7,29.1-22.54,46.31-19.26,36.07,5.74,50.82,43.44,61.11,73.93"
            style={{ fill: "none", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <path
            d="m458.7,61.16c-46.31,23.36-84.84,58.61-119.26,98.77-10.66,13.11-18.85,25.41-27.05,39.34-17.21,31.15-31.15,63.11-36.91,98.23"
            style={{ fill: "none", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <path
            d="m495.58,115.25c-42.21,8.61-80.74,25.82-117.62,52.05-31.97,22.13-58.2,46.72-75.41,81.15-.82.82-2.05,3.69-2.87,4.51-8.2,14.75-13.52,28.28-18.2,44.71"
            style={{ fill: "none", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <path
            d="m479.19,180.01c-18.21-1.09-36.54-.34-54.6,2.23-18.1,2.57-35.95,6.98-53.15,13.19-17.54,6.34-34.66,14.39-49.94,25.16-12.74,8.98-24.38,19.6-34.01,31.88-9.22,11.75-16.53,25.03-21.02,39.3-.57,1.8-1.09,3.61-1.56,5.44"
            style={{ fill: "none", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <path
            d="m384.93,236.57c-14.34-13.52-34.84-25-55.33-16.8-31.97,13.11-50,45.9-60.17,77.81"
            style={{ fill: "none", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <circle
            cx="3.37"
            cy="127.14"
            r="2.87"
            style={{ fill: "#472ed1", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <path
            d="m378.37,21.81c-33.2,38.93-57.79,84.02-77.46,131.56-18.85,45.9-31.15,94.26-36.16,143.74"
            style={{ fill: "none", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <circle
            cx="36.16"
            cy="67.3"
            r="2.87"
            style={{ fill: "#472ed1", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <circle
            cx="33.7"
            cy="191.07"
            r="2.87"
            style={{ fill: "#472ed1", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <circle
            cx="136.16"
            cy="242.71"
            r="2.87"
            style={{ fill: "#472ed1", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <circle
            cx="384.52"
            cy="236.16"
            r="2.87"
            style={{ fill: "#472ed1", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <circle
            cx="479.6"
            cy="180.42"
            r="2.87"
            style={{ fill: "#472ed1", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <circle
            cx="497.63"
            cy="114.84"
            r="2.87"
            style={{ fill: "#472ed1", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <circle
            cx="459.11"
            cy="60.75"
            r="2.87"
            style={{ fill: "#472ed1", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <circle
            cx="377.96"
            cy="22.22"
            r="2.87"
            style={{ fill: "#472ed1", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <circle
            cx="249.27"
            cy="3.37"
            r="2.87"
            style={{ fill: "#472ed1", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
          <circle
            cx="123.04"
            cy="22.22"
            r="2.87"
            style={{ fill: "#472ed1", stroke: "#472ed1", strokeMiterlimit: 10 }}
          />
        </svg>
      </Box>

      {/* CSS Keyframes (global style) */}
      <style>
        {`
          @keyframes fallingChip {
            0% {
              transform: translateY(0) rotate(0deg) scale(0.8);
              opacity: 0;
            }
            10% {
              opacity: 1;
              transform: translateY(10vh) rotate(15deg) scale(1);
            }
            30% {
              transform: translateY(30vh) rotate(25deg) scale(1.05);
            }
            50% {
              transform: translateY(50vh) rotate(35deg) scale(0.95);
            }
            70% {
              transform: translateY(70vh) rotate(50deg) scale(0.75);
              opacity: 0.8;
            }
            85% {
              transform: translateY(85vh) rotate(60deg) scale(0.5);
              opacity: 0.5;
            }
            100% {
              transform: translateY(100vh) rotate(75deg) scale(0.3);
              opacity: 0;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default Wormhole;
